import LexusArrow from '@assets/icons/lexusArrow.svg'
import { useBrand } from '@contexts/useBrand'
import type { ReactElement } from 'react'

type Props = {
  children: string | ReactElement[]
  href?: string
  target?: string
  rel?: string
  onClick?: () => void
  theme?: 'primary' | 'secondary'
}

const CTA = ({ children, href, theme = 'primary', ...rest }: Props) => {
  const { className: restClassName, ...otherRest } = rest

  const brand = useBrand()
  let classes = `${restClassName || ''} ${
    theme === 'secondary'
      ? 'bg-white text-base hover:text-white'
      : 'bg-base text-white'
  } inline-flex items-center justify-center px-6 py-3 border border-base outline-0 hover:bg-base-hover active:bg-base-hover focus:bg-base-hover disabled:cursor-not-allowed disabled:bg-base-hover  `
  let inside = children

  if (brand === 'lexus') {
    classes = `${
      restClassName || ''
    } group-button inline-flex items-center justify-end !leading-10 pl-4 uppercase rounded bg-secondary text-white outline-0 hover:bg-secondary-hover active:bg-secondary-hover focus:bg-secondary-hover disabled:cursor-not-allowed disabled:bg-secondary-hover`
    inside = (
      <>
        <span className="text-sm text-center font-semibold !leading-[44px]">
          {children}
        </span>
        <LexusArrow className={`ml-2 mr-4 group-button-hover:mx-3`} />
      </>
    )
  }

  if (href) {
    return (
      <a href={href} className={classes} {...otherRest}>
        {inside}
      </a>
    )
  }

  return (
    <button type="button" className={classes} {...otherRest}>
      {inside}
    </button>
  )
}

export default CTA
